// extracted by mini-css-extract-plugin
export var label = "_bi-1";
export var reminder = "_bi-0";